import {useState} from 'react'
import {CourseBotConnect} from './components/CourseBotConnect'
import {HomeWorkspace} from './components/HomeWorkspace'
import { useOrbit } from './store'
import { Header } from './components/Header'
import { TabBar } from './components/TabBar'
import { ChatView } from './components/ChatView'
import { ClockView } from './components/ClockView'
import { CalendarView } from './components/CalendarView'
import { BrowserView } from './components/BrowserView'
import { ContentWorkspace } from './components/ContentWorkspace'
import { EducationWorkspace } from './components/EducationWorkspace'
import { getWebApp } from './telegram'

const contentHeaders = (): Record<string,string> => getWebApp()?.initData ? { 'X-Telegram-Init-Data': getWebApp()!.initData } : {}

export function App() {
  const { tab } = useOrbit()
  const [showCourse,setShowCourse]=useState(()=>new URLSearchParams(window.location.search).get('connect')==='course-bot')
  if(showCourse)return <CourseBotConnect />

  return (
    <div className="flex h-full flex-col bg-bg-primary text-text-primary">
      <Header />
      <main className="flex-1 overflow-hidden">
        {tab === 'home' && <HomeWorkspace endpoint={import.meta.env.DEV ? 'http://127.0.0.1:9121/api/home' : '/api/home'} authHeaders={contentHeaders} />}
        {tab === 'chat' && <ChatView />}
        {tab === 'clock' && <ClockView />}
        {tab === 'calendar' && <CalendarView />}
        {tab === 'content' && <ContentWorkspace endpoint={import.meta.env.DEV ? 'http://127.0.0.1:9121/api/content' : '/api/content'} authHeaders={contentHeaders} />}
        {tab === 'education' && <button onClick={()=>{window.history.replaceState(null,'','?connect=course-bot'+window.location.hash);setShowCourse(true)}} className='block px-4 py-3 text-sm text-accent-primary'>Подключить @choopacourses_bot</button>}
        {tab === 'education' && <EducationWorkspace endpoint={import.meta.env.DEV ? 'http://127.0.0.1:9121/api/education' : '/api/education'} authHeaders={contentHeaders} />}
        {tab === 'browser' && <BrowserView />}
      </main>
      <TabBar />
    </div>
  )
}
